import { cn } from "@/utilities/app-utils";
import { tailwind } from "@/utilities/tailwind-utils";
import { useMemo } from "react";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  text?: string;
  showText?: boolean;
  fullScreen?: boolean;
  spinnerClassName?: string;
}

export function LoadingSpinner({
  size = "lg",
  className,
  text,
  showText = true,
  fullScreen = false,
  spinnerClassName
}: LoadingSpinnerProps) {
  const sizeClasses = useMemo(
    () => ({
      sm: tailwind.sizes.size4,
      md: tailwind.sizes.size8,
      lg: tailwind.sizes.size10,
      xl: tailwind.sizes.size12
    }),
    []
  );

  const containerClasses = useMemo(
    () =>
      fullScreen
        ? cn("flex items-center justify-center min-h-screen")
        : cn("flex flex-col items-center justify-center"),
    [fullScreen]
  );

  return (
    <div className={cn(containerClasses, className)}>
      <div
        className={cn(
          "animate-spin rounded-full border-b-2 border-primary",
          sizeClasses[size],
          spinnerClassName
        )}
      />
      {showText && text && (
        <p className={cn("mt-4 text-center", tailwind.typography.textMuted)}>
          {text}
        </p>
      )}
    </div>
  );
}
